

	import { Component, Watch } from 'vue-property-decorator';
	import { PersonDetailsView } from '@client/views/industry/PersonDetailsView';
	import { Artist } from '@shared/models';

	@Component({})
	export default class ArtistDetails extends PersonDetailsView<Artist> {

		public model: Artist = new Artist();
		public imageUrl: string = '';

		/** Fires when this view is mounted */
		public async mounted() {
			if (this.$route.name === 'artist-details' ) { this.$router.push({ name: 'artist-decks', params: { id: this.$route.params.id }}); }
			this.loading = true;
			try {
				const modelId = this.$route.params.id;
				this.model = await this.$api.artistService.get(modelId);
				this.setTitle(`Skate Lurker - ${this.model.displayName} Skate Artist`);
				this.imageUrl = `https://lurker.blob.core.windows.net/artists/d_art_${this.model.id}.jpg`;
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this artist');
			} finally {
				this.loading = false;
			}
		}

		/** Displays a stub image if the current image is broken */
		public handleBrokenImage($event: any) {
			$event.target.src = `${this.settings.baseUrl}/Assets/Stubs/default-artist.jpg`;
		}

	}

